import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, Radio, Row } from 'antd'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import ProductTable from './ProductTable'
import { UnorderedListOutlined, PieChartOutlined } from '@ant-design/icons'
import ProductChart from './ProductChart'
import { TopSaleReq } from 'Store/dashboard/types'
import { selectCurrentUser } from 'Store/user/selector'
import { topSaleDashboardAPI } from 'Store/dashboard/api'
import { selectTopsaleDashboard } from 'Store/dashboard/selector'
import { DashboardDataType } from 'helpers/constanst'

type Props = {} & ReduxProps

const TopProduct: React.FunctionComponent<Props> = props => {
  const { currentUser, data } = props
  const [topSaleMode, setTopSaleMode] = useState('list' as 'list' | 'graph')
  const [topOrderMode, setTopOrderMode] = useState('list' as 'list' | 'graph')
  const dispatch = useDispatch()

  const onGetData = (): void => {
    const req: TopSaleReq = {
      mid: currentUser?.activeMerchant?.id || 0,
    }

    dispatch(topSaleDashboardAPI(req, currentUser.accessToken))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetData()
    }
  }, [])

  const renderHeader = (type: DashboardDataType, mode: string) => {
    const isSale = type === DashboardDataType.SALE
    const title = isSale ? 'ยอดขายสูงสุด 20 อันดับ' : 'จำนวนสั่งซื้อสูงสุด 20 อันดับ'
    return (
      <Row justify="space-between" gutter={[16, 16]} align="middle">
        <Col>
          <BoxTitle>
            ผลิตภัณฑ์ <Desc>({title})</Desc>
          </BoxTitle>
        </Col>
        <Col>
          <Radio.Group
            size="middle"
            value={mode}
            onChange={(e: any) => {
              const mode = e.target.value
              isSale ? setTopSaleMode(mode) : setTopOrderMode(mode)
            }}
          >
            <Radio.Button value="list">
              <UnorderedListOutlined />
            </Radio.Button>
            <Radio.Button value="graph">
              <PieChartOutlined />
            </Radio.Button>
          </Radio.Group>
        </Col>
      </Row>
    )
  }

  return (
    <Row gutter={[16, 16]}>
      <Col md={24} xs={24}>
        <Row gutter={[16, 16]} justify="space-between" align="top">
          <Col lg={12} md={24} sm={24} xs={24}>
            {renderHeader(DashboardDataType.SALE, topSaleMode)}
            {topSaleMode === 'list' ? (
              <ProductTable data={data?.top_sale_price || []} type={DashboardDataType.SALE} />
            ) : (
              <BoxWrapper>
                <ProductChart data={data?.top_sale_price || []} type={DashboardDataType.SALE} />
              </BoxWrapper>
            )}
          </Col>
          <Col lg={12} md={24} sm={24} xs={24}>
            {renderHeader(DashboardDataType.ORDER, topOrderMode)}
            {topOrderMode === 'list' ? (
              <ProductTable data={data?.top_sale_quantity || []} type={DashboardDataType.ORDER} />
            ) : (
              <BoxWrapper>
                <ProductChart data={data?.top_sale_quantity || []} type={DashboardDataType.ORDER} />
              </BoxWrapper>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

const BoxWrapper = styled.div`
  padding: 20px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  border-radius: 20px;
  border-color: transparent;
  margin-top: 10px;
`

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const Desc = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    data: selectTopsaleDashboard(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(TopProduct)
